import { Action } from '../core/action'
import { Signal } from '../core/signal'
import { ArrayState, DeepState } from '../core/state'
import { DesignView, ExportType, OsSelectableView, ViewDirection } from '../types'
import { AutoDesignRunAndLoadOptions } from '../types/autoDesign'

export const studio = {
  // State
  availableImagery: new DeepState<any | undefined>(undefined),
  views: new ArrayState<DesignView>([]),

  // Actions
  autoDesignRunAndLoad: new Action<[options: AutoDesignRunAndLoadOptions], any>(),
  autoDesignRunAndLoadFromEquipment: new Action<[any, any, any, any, any, any, any, any, any?, any?, any?], any>(),
  setComponents: new Action<[components: any[], keepExistingComponents?: Boolean, systemUuid?: string]>(),
  removeObject: new Action<[objectUuid: string]>(),
  getLoadedData: new Action<[], any>(),
  getSelectedSystemData: new Action<[], any>(),
  getSystemImageUrl: new Action<[systemUuid: string, width?: number, height?: number], string>(),
  /**
   * @deprecated
   */
  executeCommand: new Action<[commandName: string, commandArgs: any[]]>(),
  /**
   * @deprecated
   */
  executeCommandFromJson: new Action<[commandName: string, json: any]>(),
  /**
   * @deprecated
   */
  callFunction: new Action<[singletonName: string, functionName: string, args: any[]]>(),
  view: {
    setShadingVisibility: new Action<[value?: boolean]>(),
    animateToLonLat: new Action<[lonlat: [number, number], duration?: number], void>(),
    animateToDirection: new Action<[direction: ViewDirection], void>(),
    selectedView: new Action<[], OsSelectableView>(),
  },
  export: {
    isAvailable: new Action<[exportType: ExportType], boolean>(),
    generate: new Action<[exportType: ExportType], any>(),
    generateAndDownload: new Action<[exportType: ExportType], any>(),
  },
  commands: {
    setObjectProp: new Action<
      [
        objectOrUuid: unknown,
        attributeName: string,
        newValue: any,
        commandUUID?: unknown,
        updatable?: unknown,
        valueFormat?: unknown
      ]
    >(),
  },

  // Signals
  windowResize: new Signal(),
  objectSelected: new Signal(),
  objectAdded: new Signal(),
  objectChanged: new Signal(),
  objectRemoved: new Signal(),
  sceneLoaded: new Signal(),
  queueProcessed: new Signal(),
} as const
